require('./styled-select.less');
require('../m-scrollbar-default/m-scrollbar-default');

let styleSelects = function($select) {
    $select.each(function() {
        var $this = $(this);

        $this
            .select2({
                language: 'ru',
                minimumResultsForSearch: Infinity,
                dropdownParent: $this.parent()
            })
            .on('select2:open', function() {
                var $options = $this
                    .parent()
                    .find('.select2-container--default .select2-results > .select2-results__options');

                $options.mCustomScrollbar('destroy');
                $options.mCustomScrollbar('update');

                setTimeout(function() {
                    $options.mCustomScrollbar({
                        axis: 'y',
                        scrollbarPosition: 'inside',
                        advanced: {
                            updateOnContentResize: true
                        },
                        live: true
                    });
                }, 0);
            });
    });
};

module.exports.styleSelects = styleSelects;



// WEBPACK FOOTER //
// ./blocks/styled-select/styled-select.js